import { Flex, Spin } from 'antd';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import LabCard from './labCard';
import { fetchPatientLabTests } from '../../../../../../Redux/actions/patientActions';
import { setSelectedRpmPatient } from '../../../../../../Redux/actions/rpmActions';

function Index() {
    const { isLoading, labTestsList } = useSelector((state) => state.patients);
    const { selectedRpmPatient } = useSelector((state) => state.rpm);
    const dispatch = useDispatch();

    useEffect(() => {
        const payload = {
            patientId: selectedRpmPatient?.patientId,
            status: 1,
        }
        dispatch(fetchPatientLabTests(payload));
    }, []);

    useEffect(() => {
        if (!selectedRpmPatient) {
            const rpmPatientJson = localStorage.getItem('rpmPatient');
            const rpmPatientObject = rpmPatientJson ? JSON.parse(rpmPatientJson) : null;
            if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
        }
    }, []);

    return (
        <div>
            {
                isLoading && labTestsList?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]">
                        <Flex align="center" gap="middle">
                            <Spin size="large" tip="Loading" />
                        </Flex>
                    </div>
                ) :
                    labTestsList?.length === 0 ?
                        (<div className="flex flex-col items-center justify-center">
                            <p className="font-medium">No data found!!</p>
                        </div>)
                        :
                        labTestsList?.map((test, idx) => (
                            <LabCard labTest={test} key={idx} />
                        ))
            }
        </div>
    )
}

export default Index;